import { closest } from 'helpers/index'

export const isInsidePopover = (target: HTMLElement) =>
  !!closest(target, (t) => { return (
    t.getAttribute && t.getAttribute('data-type') === 'vac-req-pop'
  )})



// WEBPACK FOOTER //
// ./src/containers/app/absencePlaner/absenceActionBar/requestManager/requestsPopover/localHelpers.js